import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

interface ConfirmDeleteRelationshipDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  relationshipDescription: string;
  deleting: boolean;
}

const ConfirmDeleteRelationshipDialog: React.FC<ConfirmDeleteRelationshipDialogProps> = ({
  open,
  onClose,
  onConfirm,
  relationshipDescription,
  deleting,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="error" />
          Confirmar Eliminación
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography>
          ¿Está seguro que desea eliminar la relación{' '}
          <strong>{relationshipDescription}</strong>? Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" disabled={deleting}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={deleting}
          startIcon={deleting ? <CircularProgress size={20} /> : null}
        >
          {deleting ? 'Eliminando...' : 'Eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteRelationshipDialog;
